import { useState } from 'react';
import { useRouter } from 'next/navigation';
import { pathsByRole } from '@/lib/constants/roles';
import { obtenerUser } from '@/modules/user/application/obtenerUser';
import { loginUser } from '@/modules/user/application/loginUser';
import { obtenerRolUser } from '@/modules/user/application/obtenerRolUser';

export function useLoginForm() {
  const router = useRouter();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const { data } = await loginUser(email, password);
      const user = data?.user;
      if (!user)
        throw new Error(
          'No se pudo obtener el usuario después del login. Es posible que no esté verificado.',
        );
      const { needs_password_reset, new_user } = user.user_metadata || {};
      if (needs_password_reset === true) {
        router.push('/cambiar-password');
        return;
      }
      if (new_user === true) {
        router.push('/bienvenida');
        return;
      }
      const usuario = await obtenerUser(user.id);
      if (!usuario) throw new Error('Usuario no encontrado');

      const rol = await obtenerRolUser(usuario.id, usuario.tenant_id);
      if (!rol) throw new Error('Rol no definido');

      const redirectTo =
        pathsByRole[rol.role_code as keyof typeof pathsByRole] || '/';
      router.push(redirectTo);
    } catch (err: unknown) {
      if (err instanceof Error) {
        setError(err.message || 'Error al iniciar sesión');
      } else {
        setError('An unknown error occurred');
      }
    } finally {
      setIsLoading(false);
    }
  };

  return {
    email,
    setEmail,
    password,
    setPassword,
    error,
    isLoading,
    handleSubmit,
  };
}
